import React from 'react';
import { customIcons, DynamicIcon } from '../icons';

type PolicyProps = {
	title?: string;
	icon?: any;
	children?: any;
	label?: string
}

export const Policy = ({ title, icon, children, label }: PolicyProps) => {
	return (
		<div className='flex font-poppins'>
			<div className="flex flex-col justify-center items-center gap-2 p-2">
				{React.isValidElement(icon) ? (
					icon
				) : label ? (
					<img src={icon} alt={label} width={20} height={20} className='min-w-5 min-h-5' />
				) : (
					icon ? customIcons({ filter: 'none', width: 20, height: 20, minWidth: 20, minHeight: 20 })[icon] ?? <DynamicIcon iconName={icon} /> : null
				)}
				<div className='w-0.5 h-full bg-zinc-500' />
			</div>
			<div className="flex flex-col justify-center p-1">
				<span className="text-zinc-100 text-base font-semibold pb-1">{title}</span>
				<span className="text-zinc-300 text-base leading-7">{children}</span>
			</div>
		</div>
	);
};
